export const useCostPoolsStore = defineStore('costPools', {
  state: () => ({
    costPools: null as PaginatedCostPool | null,
  }),
  getters: {
    getCostPools: (state) => (state.costPools !== null ? state.costPools.items : []),
  },
  actions: {
    setCostPools(costPools: PaginatedCostPool) {
      useLocalStorage().setItem('costPools', costPools);
      this.costPools = costPools;
    },
    async createCostPool(costPool: CostPoolCreateUpdate): Promise<CostPool | undefined> {
      try {
        const {data} = await apiPostCostPool(costPool);
        pushDataToPaginatedState(this.costPools, data);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async readCostPools({
      offset,
      limit,
      search,
    }: {
      offset?: number;
      limit?: number;
      search?: string;
    } = {}): Promise<PaginatedCostPool | undefined> {
      // Parse the local storage value & set the state.
      const localStorageCostPools: PaginatedCostPool | null =
        useLocalStorage().getItem('costPools');
      if (localStorageCostPools !== null) {
        this.costPools = localStorageCostPools;
      }
      try {
        const {data} = await apiGetCostPools(limit, offset, search);
        this.costPools = data;
        useLocalStorage().setItem('costPools', data);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async readCostPoolById(id: string | number): Promise<CostPool | undefined> {
      // Parse & return the local storage value.
      const localStorageCostPools: PaginatedCostPool | null =
        useLocalStorage().getItem('costPools');
      if (localStorageCostPools) {
        const foundCostPool = localStorageCostPools.items.find((c) => c.id === id);
        if (foundCostPool !== undefined) return foundCostPool;
      }
      try {
        const {data} = await apiGetCostPool(id);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async updateCostPool(costPool: CostPoolCreateUpdate): Promise<CostPool | undefined> {
      try {
        const response = await apiPutCostPool(costPool);
        const data: CostPool = response.data;
        //find & update the object in state.
        if (this.costPools !== null) {
          const index = this.costPools.items.findIndex((c) => c.id === data.id);
          if (index >= 0) {
            Object.assign(this.costPools.items[index], data);
            useLocalStorage().setItem('costPools', this.costPools);
          }
        }
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async deleteCostPool(id: string | number): Promise<void> {
      try {
        await apiDeleteCostPool(id);
        if (this.costPools !== null) {
          const index = this.costPools.items.findIndex((c) => c.id === id);
          if (index >= 0) {
            this.costPools.items.splice(index, 1);
            useLocalStorage().setItem('costPools', this.costPools);
          }
          this.costPools.total -= 1;
        }
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
  },
});
